import { FC } from 'react';
import { Box, Skeleton, Typography, useTheme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';

const HeaderGridContainer = styled(Grid)`
  width: 100%;
  margin-bottom: 1rem;
`;

const TextGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const NoteHeaderTitle = styled(Typography)`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.2;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

interface PublicNoteHeaderProps {
  title: string;
  date: string;
  isLoadingNote?: boolean;
  sharedBy?: {
    name: string;
    email?: string;
  } | null;
}

const PublicNoteHeader: FC<PublicNoteHeaderProps> = ({ title, date, isLoadingNote, sharedBy }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <HeaderGridContainer container spacing={isMobile ? 2 : 4}>
      {!isLoadingNote && (
        <TextGrid size={12}>
          <NoteHeaderTitle variant="h1">{title}</NoteHeaderTitle>
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              gap: isMobile ? 0.5 : 1,
            }}
          >
            <Typography variant="body1" color="text.secondary">
              {date}
            </Typography>
            {sharedBy && (
              <Typography
                variant="body1"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: 'primary.light',
                  color: 'primary.contrastText',
                  px: isMobile ? 0.75 : 1,
                  py: isMobile ? 0.25 : 0.5,
                  borderRadius: 1,
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  ml: isMobile ? 0 : 1,
                  mt: isMobile ? 0.5 : 0,
                }}
              >
                Shared by: {sharedBy.name}
              </Typography>
            )}
          </Box>
        </TextGrid>
      )}
      {isLoadingNote && (
        <TextGrid size={12}>
          <Skeleton variant="text" width="100%" height={70} />
        </TextGrid>
      )}
    </HeaderGridContainer>
  );
};

export default PublicNoteHeader;
